module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.0e9b8785.png";